import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import { memo } from "react"

import { PROCEDURE_STEP_COMPLETION_STATUSES } from "../../constants"
import { ProcedureStepCompletionStatus } from "../../enums/procedures"
import { procedureStepCompletionStatusData } from "../../mappings/procedures"
import { ProcedureStepCompletionStatusIcon } from "../Icons/ProcedureStepCompletionStatusIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type ProcedureStepCompletionStatusSelectGroupProps = MenuSelectGroupProps<ProcedureStepCompletionStatus> & {
	statuses?: ProcedureStepCompletionStatus[]
}

export const ProcedureStepCompletionStatusSelectGroup = memo<ProcedureStepCompletionStatusSelectGroupProps>((props) => {
	const { ref, statuses = PROCEDURE_STEP_COMPLETION_STATUSES, ...rest } = props

	return (
		<Menu.SelectGroup<ProcedureStepCompletionStatus> ref={ref} {...rest}>
			{statuses.map((status) => {
				const { label } = procedureStepCompletionStatusData[status]

				return (
					<SelectItemTemplate<ProcedureStepCompletionStatus> key={status} value={status}>
						<ProcedureStepCompletionStatusIcon status={status} />
						<Text className="truncate">{label}</Text>
					</SelectItemTemplate>
				)
			})}
		</Menu.SelectGroup>
	)
})
ProcedureStepCompletionStatusSelectGroup.displayName = "ProcedureStepCompletionStatusSelectGroup"
